import $ from 'jquery';

// eslint-disable-next-line no-undef
const object = gralObject;

const initializeBlock = ($block) => {
    const current = $block.find('.custom-smile');
    const args = JSON.parse(current.attr('data-args'));
    const desktopWrapper = current.find('.custom-smile__screen--desktop');
    const tabletWrapper = current.find('.custom-smile__screen--tablet');
    const mobileWrapper = current.find('.custom-smile__screen--mobile');
    const data = {
        args,
        action: 'gral_custom_advertisement',
        nonce: object.nonce,
    };

    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data,
        success: (res) => {
            if (res.success) {
                setTimeout(() => {
                    desktopWrapper.html(res.data.desktopContent);
                    tabletWrapper.html(res.data.tabletContent);
                    mobileWrapper.html(res.data.mobileContent);
                }, 1000);
            }
        },
    });
};

$('.custom-smile-block').each(function () {
    initializeBlock($(this));
});

if (window.acf) {
    window.acf.addAction(
        'render_block_preview/type=gral-custom-banners',
        initializeBlock
    );
}
